import { get, post,put } from "../Config";

// GET
export function BannerList() {
  return get({ url: `/api/koala/v1/banner`});
}
